import { createFeatureSelector, createSelector } from "@ngrx/store";

export const selectorFriend = createSelector(
    createFeatureSelector('friend'),
    (state: any) => state
);